module.exports = __webpack_public_path__ + "static/media/7.393b3ec3.jpg";